import { makeAutoObservable } from "mobx"

import Package from "./Package"
import { Person, PersonProps } from "./Person"
import WaitlistStatus from "./WaitlistStatus"

export interface ParticipationProps {
  id: string
  tripId: number
  cancelled: boolean
  package: any
  person: PersonProps
  waitlistStatus: WaitlistStatus
}

export default class Participation {
  id: string
  tripId: number
  cancelled: boolean
  package: Package
  person: Person
  waitlistStatus: WaitlistStatus

  constructor(props: any) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.id = props.id
    this.tripId = props.tripId
    this.cancelled = props.cancelled
    this.package = props.package && new Package(props.package)
    this.person = props.person && new Person(props.person)
    this.waitlistStatus = props.waitlistStatus && new WaitlistStatus(props.waitlistStatus)
  }
}
